<template>
  <div>
    <!-- 正常弹窗 -->
    <el-dialog
        v-show="!isMinimize"
        ref="dialogRef"
        :visible.sync="dialogVisible"
        :width="width"
        :title="title"
        :close-on-click-modal="false"
        :show-close="false"
        :append-to-body="true"
        :modal="false"
        :fullscreen="isFullscreen"
        :class="['min-dialog-normal', { 'is-fullscreen': isFullscreen }]"
        :top="'5vh'"
        :lock-scroll="false"
        v-dialogDrag
    >
      <!-- 自定义头部 -->
      <div slot="title" class="custom-header">
        <span class="title-text">{{ title }}</span>
        <div class="header-btns">
          <button class="header-btn" @click.stop="minimize" title="最小化">
            <i class="el-icon-minus"></i>
          </button>
          <button class="header-btn" @click.stop="toggleFullscreen" :title="isFullscreen ? '还原' : '最大化'">
            <i :class="isFullscreen ? 'el-icon-copy-document' : 'el-icon-full-screen'"></i>
          </button>
          <button class="header-btn close-btn" @click.stop="close" title="关闭">
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="dialog-body">
        <slot></slot>
      </div>

      <div slot="footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
    </el-dialog>

    <!-- 最小化状态：独立的标签条 -->
    <div
        v-show="isMinimize"
        class="minimize-bar"
        :style="minimizeBarStyle"
        @click="restore"
    >
      <span class="minimize-index">{{ minimizeIndex + 1 }}</span>
      <span class="minimize-title">{{ title }}</span>
      <div class="minimize-btns">
        <button class="minimize-btn" @click.stop="restore" title="还原">
          <i class="el-icon-full-screen"></i>
        </button>
        <button class="minimize-btn close" @click.stop="close" title="关闭">
          <i class="el-icon-close"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MinDialog',
    props: {
      visible: { type: Boolean, default: false },
      title: { type: String, default: '弹窗标题' },
      width: { type: String, default: '70%' },
      minimizeIndex: { type: Number, default: -1 },
      dialogId: { type: Number, default: 0 }
    },
    data() {
      return {
        isMinimize: false,
        isFullscreen: false
      }
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible && !this.isMinimize
        },
        set(val) {
          this.$emit('update:visible', val)
          if (!val) {
            this.isMinimize = false
            this.isFullscreen = false
          }
        }
      },
      minimizeBarStyle() {
        if (!this.isMinimize || this.minimizeIndex < 0) return {}
        const left = 20 + this.minimizeIndex * 200
        const colors = [
          'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
          'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
          'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
          'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
          'linear-gradient(135deg, #fccb90 0%, #d57eeb 100%)'
        ]
        return {
          position: 'fixed',
          left: left + 'px',
          bottom: '20px',
          zIndex: 3000 + this.minimizeIndex,
          background: colors[this.minimizeIndex % colors.length]
        }
      }
    },
    watch: {
      visible(val) {
        if (!val) {
          this.isMinimize = false
          this.isFullscreen = false
        }
      }
    },
    methods: {
      minimize() {
        this.isMinimize = true
        this.isFullscreen = false
        this.$emit('minimize', { id: this.dialogId, isMinimize: true })
      },

      restore() {
        this.isMinimize = false
        this.$emit('restore', { id: this.dialogId })
      },

      toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen
      },

      close() {
        this.isMinimize = false
        this.isFullscreen = false
        this.$emit('update:visible', false)
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
  /* ===== 正常弹窗样式 ===== */
  .min-dialog-normal >>> .el-dialog {
    display: flex;
    flex-direction: column;
    height: 90vh;
    max-height: 90vh;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
  }

  .min-dialog-normal >>> .el-dialog__header {
    padding: 0 !important;
    border-bottom: 1px solid #ebeef5;
    user-select: none;
    background: #fafafa;
    flex-shrink: 0;
  }

  .min-dialog-normal >>> .el-dialog__body {
    flex: 1;
    padding: 0 !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0;
    height: 100%;
  }

  .custom-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    height: 44px;
    line-height: 44px;
  }

  .title-text {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
  }

  .header-btns {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .header-btn {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    color: #606266;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    transition: all 0.25s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-btn:hover {
    background-color: rgba(64, 158, 255, 0.1);
    color: #409eff;
  }

  .close-btn:hover {
    background-color: #f56c6c !important;
    color: #fff !important;
  }

  /* ===== dialog-body 占满剩余空间 ===== */
  .dialog-body {
    flex: 1;
    padding: 0;
    overflow: hidden;
    min-height: 0;
    height: 100%;
    position: relative;
  }

  .dialog-body ::v-deep iframe,
  .dialog-body iframe {
    width: 100% !important;
    height: 100% !important;
    min-height: 0 !important;
    border: none;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  /* ===== 全屏状态 ===== */
  .min-dialog-normal.is-fullscreen >>> .el-dialog {
    width: 100% !important;
    height: 100vh !important;
    margin: 0 !important;
    top: 0 !important;
    border-radius: 0 !important;
    max-height: 100vh !important;
  }

  .min-dialog-normal.is-fullscreen >>> .el-dialog__body {
    height: calc(100vh - 44px) !important;
    min-height: calc(100vh - 44px) !important;
    flex: none;
  }

  .min-dialog-normal.is-fullscreen .dialog-body {
    height: 100%;
  }

  /* ===== 最小化标签条样式 ===== */
  .minimize-bar {
    width: 180px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    gap: 6px;
    cursor: pointer;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
    border: 1px solid rgba(255, 255, 255, 0.2);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .minimize-bar:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  }

  .minimize-index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .minimize-title {
    font-size: 12px;
    color: #fff;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }

  .minimize-btns {
    display: flex;
    gap: 2px;
    flex-shrink: 0;
  }

  .minimize-btn {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.8);
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 11px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .minimize-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
  }

  .minimize-btn.close:hover {
    background: rgba(255, 0, 0, 0.4) !important;
  }

  /* 移除 Element UI 默认的 padding */
  ::v-deep .el-dialog__body {
    padding: 0 !important;
  }
</style>
